import React, { FunctionComponent } from "react";
import BannerContactContent from "./BannerContactContent.model";
import styles from "./BannerContact.module.scss";
import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import combineClasses from "helpers/combine-classes";
import Dictionary from "components/Dictionary/Dictionary";

const BannerContact: FunctionComponent<BannerContactContent> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);

    const media = props.content.media;
    const imageCrop = getImageCrop(media?.crops, undefined, "Ultrawide (21:9)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, media?.width, media?.height);
    const backgroundColorStyles = { backgroundColor: "transparent" };

    if (props.settings.backgroundColor) {
        backgroundColorStyles.backgroundColor = `#${props.settings.backgroundColor.color}`;
    }

    return (
        <div className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            {/* Background*/}
            <div
                className={styles.background}
                style={backgroundColorStyles}
            >
                {media ? (
                    <ImageViewer
                        className={styles.image}
                        src={media?.url || media}
                        crop={imageCrop}
                        type="cover"
                        focalPoint={media.focalPoint}
                        {...imageAspectRatio}
                    />
                ) : null}
            </div>

            {/* Content */}
            <div className={styles.container}>
                <div className={styles.content}>
                    <h2 className={styles.headline}>{props.content.headline}</h2>
                    <div className={styles.addressLines}>
                        <div>{props.content.addressLine1}</div>
                        <div>{props.content.addressLine2}</div>
                    </div>
                    <div>
                        {/* Phone */}
                        <a
                            className={styles.anchor}
                            href={`tel:${props.content.phoneNumber}`}
                        >
                            {props.content.phoneNumber}
                        </a>
                    </div>
                    <div>
                        {/* Mail */}
                        <a
                            className={styles.anchor}
                            href={`mailto:${props.content.email}`}
                        >
                            {props.content.email}
                        </a>
                    </div>
                    {/* VAT Number */}
                    <div>
                        <Dictionary name="VAT_NUMBER" />
                        &nbsp;
                        {props.content.vatNumber}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerContact;
